import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { useStateContext } from '../../contexts/ContextProvider';
import { FooterPages } from '..';
import UploadIconButton from "../../components/IconButtons/UploadIconButton";
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import {formatDate} from '../../formatters/date';
import { fetchUser } from '../../utils/fetchUser';
import SearchVecino from '../Search/SearchVecino';
import { getEquipos, crearEquipo } from '../../services/Equipos';
import { getClientes } from '../../services/Clientes';
import {updateEstadoSolicitud} from '../../services/Solicitudes';
import {updateAsignacion} from '../../services/Asignaciones';
import { Toaster,toast } from 'react-hot-toast';
import DataTable from 'react-data-table-component';
import ButtonBar from '../ButtonBar';
import ButtonToolBar from '../ButtonToolBar';
import { set } from 'date-fns';

const initialState = {
empresa:'',
lin: 0,
seleccionado: 'NO',
idEquipo:'',
codigoEquipo: '',
nombreEquipo:'',
marca:'',
modelo:'',
anno:'',
horometro:0,
kilometraje:0,
valorCotizacion:0,
porcentaje:"2",
valorCotizacion2:0,
fechaEntrega: '',
responsable: '',
idUsuario: '',
proveedores: '',
comentarios: '',
urlArchivo:'',
};

const NuevaAsignacion = ({vecinoData, editableData, onChangeVecino}) => {
  const { isClicked, handleClick, setIsClicked } = useStateContext();
  const [formDataDisplay, setFormDataDisplay] = useState({});
  const [formData, setFormData] = useState(initialState);
  const [equipoData, setEquipoData] = useState([]);
  const [solicitudData, setSolicitudData] = useState([]);
  const [asignadosData, setAsignadosData] = useState([]);
  const [proveedoresData, setProveedoresData] = useState([]);
  const [selectedDateObra, setSelectedDateObra] = useState(getFirstDayOfMonth('Nada')); // Fecha inicial getFirstDayOfMonth('Fin')
  const [pdfFiles, setPdfFiles] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  const [buttons, setButtons] = useState([
    { name: 'add', label: 'Agregar', disabled: false },
    { name: 'cancel', label: 'Limpiar', disabled: false },
  ]);
  
  const [buttonsTool, setButtonsTool] = useState([
    { name: 'cancel', label: 'Cancelar', disabled: false },
    { name: 'save', label: 'Guardar', disabled: false },
    { name: 'enviar', label: 'Enviar Aprobación', disabled: false },
  ]);
  
  const [buttonsToolAp, setButtonsToolAp] = useState([
    { name: 'rechazar', label: 'Rechazar', disabled: false },
    { name: 'aprobar', label: 'Aprobar', disabled: false },
  ]);

  const userInfo = fetchUser();

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  useEffect(() => {
    if(vecinoData) {
      setFormDataDisplay(vecinoData);
      setSolicitudData(vecinoData.detalleEquipos);
      setAsignadosData(vecinoData.detalleAsignados);
    } 
  }, [vecinoData]);

  useEffect(() => {

    const fetchData = async () => {
      const misEquipos = await getEquipos();
      setEquipoData(misEquipos);      
      const misProvee = await getClientes();
      setProveedoresData(misProvee);  
      handleLimpiarMaquina();

    };
    fetchData();
  },[]);

// RETORNO DEL VALOR SELECCIONADO DE LA BUSQUEDA
const handleValorSeleccionadoChange = (idEquipoS) => {

if (idEquipoS !== '') {
  const equipoSel = equipoData.find((item) => item._id === idEquipoS);

  setFormData({ lin: formData.lin, seleccionado: "SI",idEquipo: equipoSel._id , 
    codigoEquipo: equipoSel.codigo, 
    nombreEquipo: equipoSel.nombreEquipo, 
    marca: equipoSel.marca, modelo: equipoSel.modelo, 
    anno: equipoSel.anno, horometro: equipoSel.horometro, 
    kilometraje: equipoSel.kilometraje, 
    valorCotizacion:0,porcentaje:'2', valorCotizacion2:0,fechaEntrega: '',
    responsable: userInfo.nombre, idUsuario: userInfo.usuario, proveedores: '',
    urlArchivo:'' });
  }

};

const handleRowClick = (row) => {
  setSelectedRow(row.id);
};

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleDateObraChange = (date) => {
    setSelectedDateObra(date);
  };

  const handleCompletaMaquina = async (row) =>{

    setFormData({ lin: row.lin,seleccionado: row.seleccionado, idEquipo: row.idEquipo, 
      codigoEquipo: row.codigoEquipo, 
      marca: row.marca, modelo: row.modelo, anno: row.anno, 
      horometro: row.horometro, kilometraje: row.kilometraje, 
      valorCotizacion: row.valorCotizacion, 
      porcentaje: row.porcentaje,
      valorCotizacion2: row.valorCotizacion2, fechaEntrega: row.fechaEntrega, 
      responsable: row.responsable, idUsuario: row.idUsuario, capacidad: row.capacidad, 
      proveedores: row.proveedores,  
      urlArchivo: row.urlArchivo });  
  
  };

  const handleEliminar = async (row) => {
      setAsignadosData((prevData) => prevData.filter((item) => item.lin !== row.lin));
      setAsignadosData((prevData) =>(prevData));
  };

  
  const handleLimpiarMaquina = async () => {
    setFormData({
      lin: 0,
      seleccionado: "NO",
      idEquipo: "",
      codigoEquipo: "",
      marca: "",
      modelo: "",
      anno: "",
      horometro: "",
      kilometraje: "",
      valorCotizacion: 0,
      porcentaje: "2",
      valorCotizacion2: 0,
      fechaEntrega: "",
      responsable: userInfo.nombre, 
      idUsuario: userInfo.usuario,
      capacidad: "",
      proveedores: "",
      urlArchivo: "",
    });  
  };

  const handleAgregaMaquina = async () => {
  
    console.log("ANTES DE GRABAR LINEA" + JSON.stringify(formData) );
    if (!formData.codigoEquipo || formData.codigoEquipo === "") {
      toast.error('Debe seleccionar un Equipo o Ingresar uno de Proveedor.');
      return;
    };
    if (!formData.marca || formData.marca === "") {
      toast.error('Debe Ingresar la marca.');
      return;
    };
    if (!formData.modelo || formData.modelo === "") {
      toast.error('Debe Ingresar el modelo.');
      return;
    };
    if (!formData.anno || formData.anno === "") {
      toast.error('Debe Ingresar el Año.');
      return;
    };
  /*  if (!formData.horometro || formData.horometro <= 0) {
      toast.error('Debe Ingresar el horometro.');
      return;
    };*/
    if (!formData.kilometraje || formData.kilometraje <= 0) {
      toast.error('Debe Ingresar el kilometraje.');
      return;
    };
    if (!formData.valorCotizacion || formData.valorCotizacion <= 0 ) {
      toast.error('Debe Ingresar el Valor.');
      return;
    };
    if (!formData.valorCotizacion2 || formData.valorCotizacion2 <= 0 ) {
      toast.error('Debe Ingresar el Valor + 2%.');
      return;
    };
    /*if (!formData.responsable || formData.responsable === "") {
      toast.error('Debe Ingresar el responsable');
      return;
    };*/
  
    const newData = {
      lin: formData.lin === 0 ? (asignadosData ? asignadosData.length + 1 : 1) : formData.lin,
      seleccionado: formData.seleccionado,
      idEquipo: formData.idEquipo,
      codigoEquipo: formData.codigoEquipo,
      marca: formData.marca,
      modelo: formData.modelo,
      anno: formData.anno,
      horometro: formData.horometro,
      kilometraje: formData.kilometraje,
      valorCotizacion: formData.valorCotizacion,
      porcentaje: formData.porcentaje,
      valorCotizacion2: formData.valorCotizacion2,
      fechaEntrega: selectedDateObra.toISOString(),
      responsable: formData.responsable,
      idUsuario: formData.idUsuario,
      capacidad: formData.capacidad,
      proveedores: formData.proveedores,
      urlArchivo: "Nombre Archivo",
    };
  
    if (formData.lin === 0) {
      setAsignadosData((prevData) => [...prevData, newData]);
      console.log("GRABO LINEA" + JSON.stringify(newData));
    } else {
      setAsignadosData((prevData) =>
        prevData.map((item) => (item.lin === formData.lin ? newData : item))
      );
      console.log("ACTUALIZO LINEA" + JSON.stringify(newData));
    }
  
    handleLimpiarMaquina();
  };

  const enviarAprobacion = async () =>{
    
    if (formDataDisplay.estado === 'Aprobado'){
      toast.error('La Asignación se encuentra en un estado que no permite modificación');
     // console.log('La Asignación se encuentra en un estado que no permite modificación' + vecinoData.estado );
      return;
    }

    if (asignadosData.length === 0){
      toast.error('Debe asignar al menos un Equipo.');
      // console.log('Debe asignar al menos un Equipo.');
      return;      
    };

    // debe validar que si existen registros con proveedor al menos uno tenga 
    // seleccionado === SI
    try {
        const upAsigna = {
          _id: vecinoData._id,
          detalleAsignados: asignadosData,
          idAutorizador: vecinoData.idAutorizador,
          fechaAutorizacion: vecinoData.fechaAutorizacion,
          observacmionAd: vecinoData.observacmionAd,
          estado: 'Asignado'
        };
        await updateAsignacion(upAsigna);

        onChangeVecino('REFRESH');
        setIsClicked( !isClicked.nuevaasignacion );
      } catch (error) {
        console.log(error);
        toast.error('Problemas al guardar asignación, contacte a Soporte.');
        return;
      }
  }

  const devolverAprobacion = async () =>{
    const userInfo = fetchUser();

    if (formDataDisplay.estado !== 'Asignado' ){
      toast.error('La Asignación se encuentra en un estado que no permite modificación');
      return;
    }

    if (asignadosData.length === 0){
      toast.error('Debe asignar al menos un Equipo.');
      return;      
    };

    try {
        const upAsigna = {
          _id: vecinoData._id,
          detalleAsignados: asignadosData,
          idAutorizador: vecinoData.idAutorizador,
          fechaAutorizacion: vecinoData.fechaAutorizacion,
          observacmionAd: vecinoData.observacmionAd,
          estado: 'Pendiente'
        };
        await updateAsignacion(upAsigna);

        onChangeVecino('REFRESH');
        setIsClicked( !isClicked.nuevaasignacion );
      } catch (error) {
        console.log(error);
        toast.error('Problemas al guardar asignación, contacte a Soporte.');
        return;
      }
  }

  const AprobarAsignacion = async () =>{
    const userInfo = fetchUser();

    if (formDataDisplay.estado === 'Aprobado'){
      toast.error('La Asignación se encuentra en un estado que no permite modificación');
      return;
    };

    if (asignadosData.length === 0){
      toast.error('Debe asignar al menos un Equipo.');
      return;      
    };

    try {
        const upAsigna = {
          _id: vecinoData._id,
          detalleAsignados: asignadosData,
          idAutorizador: formData.idAutorizador,
          fechaAutorizacion: formData.fechaAutorizacion,
          observacmionAd: formData.observacmionAd,
          estado: 'Aprobado'
        };
        await updateAsignacion(upAsigna);

        onChangeVecino('REFRESH');
        setIsClicked( !isClicked.nuevaasignacion );
      } catch (error) {
        console.log(error);
        toast.error('Problemas al guardar asignación, contacte a Soporte.');
        return;
      }
  }

  const handleSubmit = async () =>{
      let elEquipoEs = '';

      console.log("ESTADO " + formDataDisplay.estado );
      if (formDataDisplay && formDataDisplay.estado !== 'Pendiente'){
        toast.error('La Asignación se encuentra en un estado que no permite modificación');
        return;
      }

      if (asignadosData.length === 0){
        toast.error('Debe asignar al menos un Equipo.');
        return;      
      };

      try {

        const subsetData = asignadosData.map(item => ({
          lin: Number(item.lin),
          codigoEquipo: String(item.codigoEquipo),
          marca: String(item.marca),
          modelo: String(item.modelo),
          anno: Number(item.anno),
          horometro: Number(item.horometro),
          kilometraje: Number(item.kilometraje),
          capacidad: String(item.capacidad).trim(),
          tipo: String(item.tipo),
          idProveedor: item.idProveedor ? item.idProveedor : null,
          idEquipo: item.idEquipo ? item.idEquipo : null,
          fechaEntrega: item.fechaEntrega ? new Date(item.fechaEntrega) : null,
          valorCotizacion: Number(item.valorCotizacion),
          porcentaje: Number(item.porcentaje),
          valorCotizacion2: Number(item.valorCotizacion2),
          urlArchivo: String(item.urlArchivo),
          responsable: item.responsable ? item.responsable : null,
          seleccionado: String(item.seleccionado)
        }));

        const upAsigna = {
          _id: formDataDisplay._id,
          detalleAsignados: subsetData,
          idAutorizador: formDataDisplay.idAutorizador,
          fechaAutorizacion: formDataDisplay.fechaAutorizacion,
          observacmionAd: formDataDisplay.observacmionAd,
          estado: 'Pendiente'
        };
        await updateAsignacion(upAsigna);

        // Graba estado Solicitud "En Proceso" solo si aún no fue aprobada
        if (formDataDisplay.estadoSolicitud !== 'Aprobada') {
          const upDatSol = {
            _id: formDataDisplay.idSolicitud,
            estado: 'En Proceso'
          };
          await updateEstadoSolicitud(upDatSol);
        }
      
        onChangeVecino('REFRESH');
        setIsClicked( !isClicked.nuevaasignacion );

    } catch (error) {
      console.log(error);
      toast.error('Problemas al guardar asignación, contacte a Soporte.');
      return;
    }

  };
  

  const FileUpload = ({ onFilesUpload }) => {
    const handleFilesChange = (event) => {
      const files = event.target.files;
  
      if (files.length > 0) {
        const readers = Array.from(files).map((file) => {
          const reader = new FileReader();
  
          return new Promise((resolve) => {
            reader.onloadend = () => {
              resolve(reader.result);
            };
            reader.readAsDataURL(file);
          });
        });
  
        Promise.all(readers).then((base64Array) => {
          onFilesUpload(base64Array);
        });
      }
    };
  
    return (
      <input
        className="text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400"
        type="file"
        accept=".pdf"
        onChange={handleFilesChange}
        multiple
      />
    );
  };

  const handleFilesUpload = (base64Array) => {
    setPdfFiles([...pdfFiles, ...base64Array]);
  };

  const handleGetDocu = async (row) => {

  };

const handleRefreshDataTable = () => {  

};

  const handleButtonClick = (buttonName) => {
    // console.log(`Button clicked: ${buttonName}`);
     // Realiza acciones basadas en el botón presionado
     if (buttonName === 'add') {

        console.log("AGREGA Asigna por EQUIPO");

        handleClick('asignaporequipo');

      // handleAgregaMaquina();
     } else if (buttonName === 'cancel') {
      handleLimpiarMaquina();
    }
   };

   const handleButtonToolBarClick = (buttonName) => {
    if (buttonName === 'save') {
      handleSubmit();
    } else if (buttonName === 'enviar') {
      enviarAprobacion();
    } else if (buttonName === 'cancel') {
     // handleCancelar();
    } else if (buttonName === 'aprobar') {
      AprobarAsignacion();
    } else if (buttonName === 'rechazar') {
      devolverAprobacion();
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: 'white',
      },
    },
    headRow: {
      style: {
        backgroundColor: 'white',
        fontSize: 12,
        borderRadius: 8,
        fontWeight: '400',
        color: '#AEB2D7',
        borderWidth: 0,
        textAlign: 'center',
        headerStyles:{
          backgroundColor: '#F2F5FE',
          fontWeight: 'bold',
          color: '#2F336A',
        },
      },
    },
    rows: {
      style: {
        minHeight: '50px',
        margin: '4px 0px',
        backgroundColor: 'white',
        borderRadius: 8,
        fontSize: 10,
        rowStyles:{
          borderBottom: 1,
        }
      },
    },
  };


  const columnsEq = [
    {
      name: '',
      width: '50px',
      selector: row => row.lin,
      cell: row => (
        <div>
          {row.lin === 1 ? (
            <FaCheckCircle color="green" size={24} />
          ) : (
            <FaTimesCircle color="gray" size={24} />
          )}
        </div>
      ),
    },
    {
      name: 'Lin',
      width: '40px',
      selector: row => row.lin,
      sortable: true
    },
    {
      name: 'Fecha en Obra',
      width: '150px',
      selector: row => row.fechaEnObra,
      sortable: true
    },
    {
      name: 'Equipo',
      width: '150px',
      selector: row => row.maquina,
      sortable: true
    },
    {
      name: 'Cantidad',
      width: '100px',
      selector: row => row.cantidad,
      sortable: true
    },
    {
      name: 'Capacidad',
      width: '100px',
      selector: row => row.capacidad,
      sortable: true
    },
    {
      name: 'Permanencia',
      width: '100px',
      selector: row => row.permanencia,
      sortable: true
    },
    {
      name: 'Comentario',
      width: '100px',
      selector: row => row.comentario,
      sortable: true
    },   
  ];



  const columnsMaq = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DeleteIconButton onClick={() => handleEliminar(row)} /> )
    },
    {
      name: '',
      width: '40px',
      cell: (row) => ( <UploadIconButton onClick={() => handleGetDocu(row)} /> )
    },
    {
      name: 'Lin',
      width: '40px',
      selector: row => row.lin,
      sortable: true
    },
    {
      name: '',
      width: '100px',
      selector: row => row.seleccionado,
      sortable: true
    },
    {
      name: 'Equipo',
      width: '100px',
      selector: row => row.codigoEquipo,
      sortable: true
    },
    {
      name: 'Capacidad',
      width: '100px',
      selector: row => row.capacidad,
      sortable: true
    },
    {
      name: 'Marca',
      width: '100px',
      selector: row => row.marca,
      sortable: true
    },
    {
      name: 'Modelo',
      width: '100px',
      selector: row => row.modelo,
      sortable: true
    },
    {
      name: 'año',
      width: '100px',
      selector: row => row.anno,
      sortable: true
    },
    {
      name: 'Horometro',
      width: '100px',
      selector: row => row.horometro,
      sortable: true
    },
    {
      name: 'Kilometraje',
      width: '100px',
      selector: row => row.kilometraje,
      sortable: true
    },
    {
      name: 'Valorización',
      width: '100px',
      selector: row => row.valorCotizacion,
      sortable: true
    },
    {
      name: 'Porcentaje',
      width: '100px',
      selector: row => row.porcentaje,
      sortable: true
    },
    {
      name: 'Valorización 2%',
      width: '100px',
      selector: row => row.valorCotizacion2,
      sortable: true
    },
    {
      name: 'Fecha Entrega',
      width: '100px',
      selector: row => row.fechaEntrega,
      sortable: true
    },
    {
      name: 'Responsable',
      width: '100px',
      selector: row => row.responsable,
      sortable: true
    },
    {
      name: 'Proveedor',
      width: '100px',
      selector: row => row.proveedores,
      sortable: true
    },
    {
      name: 'Archivo',
      width: '100px',
      selector: row => row.urlArchivo,
      sortable: true
    }
  ];

  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-full p-8">
        
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
              Asignar Equipos
              </p>
            </div>

            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.nuevaasignacion)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>

        <div className="bg-gray-200 p-6 rounded-lg shadow-lg">
        <div className="grid grid-cols-2 md:grid-cols-10 gap-4" >

          <div className="flex flex-col items-start">      
            <label className="text-xs font-semibold mb-1">Fecha</label>            
            <input
              className={inputClass}
              type="text"
              placeholder=""
              name="fechaCreacion"
              value= {formatDate(vecinoData.fechaCreacion)}
              disabled
            />
          </div>
          <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Tipo Solicitud</label>
              <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="tipoSolicitud"
                  value= {formDataDisplay.tipoSolicitud}
                  disabled
                />
            </div>
          <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">N° Solicitud</label>            
              <input
              className={inputClass}
              type="text"
              placeholder=""
              name="numeroSolicitud"
              value= {vecinoData.numeroSolicitud}
              disabled
            />
          </div>
          <div className="col-span-2">
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Solicitante</label>
              <input
              className={inputClass}
              type="text"
              placeholder=""
              name="solicitante"
              value= {formDataDisplay.solicitante}
              disabled
              />
            </div>
          </div>  

               <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Jefe Of. Técnica</label>
                    <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="nombreAprobador"
                    value= {formDataDisplay.nombreAprobador}
                    disabled
                    />
                  </div> 
                </div>  
   
                  
               <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Administrador</label>
                    <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="nombreAdministrador"
                    value= {formDataDisplay.nombreAdministrador}
                    disabled
                    />
                  </div>   
                </div>  
            <div className="flex flex-col ">

                    <label className="text-xs font-semibold mb-1">Estado Solicitud</label>
                    <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="estadoSolicitud"
                    value= {formDataDisplay.estadoSolicitud}
                    disabled
                    />
                  </div>  
            </div>    
        </div>   
        <div className="mt-5 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gray-200 p-6 rounded-lg shadow-lg">
            <div className="grid grid-cols-3 md:grid-cols-6 gap-4" >


                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Centro Costo</label>
                    <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="codigoCentro"
                      value= {formDataDisplay.codigoCentro}
                      disabled
                    />
                </div>  
                <div className="col-span-4">
                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Proyecto</label>
                      <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="nombreProyecto"
                        value= {formDataDisplay.nombreProyecto}
                        disabled
                      />
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Ubicación</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="ubicacion"
                      value= {formDataDisplay.ubicacion}
                      disabled
                    />
                </div>
              </div>
               <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Observación</label>
                      <input
                          className={inputClass}
                          type="text"
                          placeholder=""
                          name="observacionAd"
                          value= {formDataDisplay.observacionAd}
                          disabled
                        />
                  </div>  
               </div>

          </div>
          <div className=" bg-gray-200 p-6 rounded-lg shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
              <div className="flex flex-col">
                <DataTable
                  columns={columnsEq}
                  data={solicitudData}
                  highlightOnHover
                  pagination={true}
                  striped
                  className="border border-gray-300 rounded-lg shadow-sm"
                  noHeader={true}
                  selectableRowsHighlight
                  customStyles={customStyles}
                  onRowClicked={handleRowClick}
                />
              </div>
            </div>
          </div>      
        </div>


        <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <div className="grid grid-cols-4 md:grid-cols-12 gap-4" >
              { editableData === "ON" &&  
                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">_</label>
                    <SearchVecino dataI={equipoData} onValorSeleccionadoChange={handleValorSeleccionadoChange}/>
                </div>
               } 
              <div className="flex flex-col">
                 <label className="text-xs font-semibold mb-1">Linea</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="lin"
                      value= {formData.lin}
                      disabled 
                      onChange={handleChange}
                    />
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Aprobado</label>
                <select className={inputClass} name="seleccionado" value= {formData.seleccionado} onChange={handleChange}>
                  <option value="SI">SI</option>
                  <option value="NO">NO</option>
                </select>
              </div> 
              <div className="col-span-2">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Equipo</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="codigoEquipo"
                      value= {formData.codigoEquipo}
                      disabled ={editableData=== "ON" ? false : true} 
                      required
                      onChange={handleChange}
                    />
                    
                </div>
              </div>  
               <div className="col-span-2">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Marca</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="marca"
                      value= {formData.marca}
                      disabled ={editableData=== "ON" ? false : true}
                      required
                      onChange={handleChange}
                    />
                </div>
              </div>  

              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Modelo</label>
                <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="modelo"
                    value= {formData.modelo}
                    disabled ={editableData=== "ON" ? false : true}
                    required
                    onChange={handleChange}
                  />
              </div>

              <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Capacidad</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="capacidad"
                      value= {formData.capacidad}
                      disabled ={editableData=== "ON" ? false : true}
                      required
                      onChange={handleChange}
                    />
                </div>

              <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Año</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="anno"
                      value= {formData.anno}
                      disabled ={editableData=== "ON" ? false : true}
                      required
                      onChange={handleChange}
                    />
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Horometro</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="horometro"
                      value= {formData.horometro}
                      disabled ={editableData=== "ON" ? false : true}
                      required
                      onChange={handleChange}
                    />
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Kilometraje</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="kilometraje"
                      value= {formData.kilometraje}
                      disabled ={editableData=== "ON" ? false : true}
                      required
                      onChange={handleChange}
                    />
                </div>
              </div>
              <div className="grid grid-cols-4 md:grid-cols-12 gap-4" >

                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Valorización</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="valorCotizacion"
                      value= {formData.valorCotizacion}
                      disabled ={editableData=== "ON" ? false : true}
                      required
                      onChange={handleChange}
                    />
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Porcentaje</label>
                  <select className={inputClass} name="porcentaje" value= {formData.porcentaje} onChange={handleChange}>
                    <option value="2">2%</option>
                    <option value="3">3%</option>
                  </select>
                </div> 
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Precio Full</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="valorCotizacion2"
                      value= {formData.valorCotizacion2}
                      disabled ={editableData=== "ON" ? false : true}
                      required
                      onChange={handleChange}
                    />
                </div>
                <div className="col-span-2">
                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Fecha Entrega</label>
                      <SeleccionaFecha
                        selectedDate={selectedDateObra}
                        handleDateChange={handleDateObraChange}
                      />
                  </div>
                </div>
                <div className="col-span-2">
                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Responsable</label>
                      <input
                          className={inputClass}
                          type="text"
                          placeholder=""
                          name="responsable"
                          value= {formData.responsable}
                          disabled
                          onChange={handleChange}
                        />
                  </div>
                </div>
                <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Proveedor</label>
                      <select className={inputClass} name="proveedores" value= {formData.proveedores} onChange={handleChange}>   
                      <option value=""></option>
                        {proveedoresData?.map((item, index) => (
                          <option value={item._id}>{item.razonSocial}</option>
                        ))}    
                      </select>                
                    </div>

                <div className="col-span-2">  
                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Archivo</label>
                      <FileUpload onFilesUpload={handleFilesUpload} />
                  </div>
                </div>        
                <div className="flex flex-col mt-4">
                  <ButtonBar buttons={buttons} onButtonClick={handleButtonClick} />
                </div>
              </div>
                   
            </div>

                <div className=" bg-white p-6 rounded-lg shadow-lg">
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                    <div className="flex flex-col">
                      <DataTable
                        columns={columnsMaq}
                        data={asignadosData}
                        highlightOnHover
                        pagination={true}
                        striped
                        className="border border-gray-300 rounded-lg shadow-sm"
                        noHeader={true}
                        selectableRowsHighlight
                        customStyles={customStyles}
                        onRowClicked={(row) => handleCompletaMaquina(row)}
                        noDataComponent={'No hay Maquinas seleccionadas'}
                      />
                    </div>

                  </div>      
                </div>

              </div>


              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
              {  editableData === "ON" && 
                <div className="flex flex-col mt-4">
                  <ButtonToolBar buttons={buttonsTool} onButtonClick={handleButtonToolBarClick} />
                </div>
                }
                {  editableData === "OFF"  &&
                <div className="flex flex-col mt-4">
                  <ButtonToolBar buttons={buttonsToolAp} onButtonClick={handleButtonToolBarClick} />
                </div>
                }

              </div>    
              <Toaster
                position="top-right"
                toastOptions={{
                  style: {
                    zIndex: 9999,
                  },
                }}
              />       
              <FooterPages />  
          </div>

        </div>
      </div>

    </form>
    
  );
};

export default NuevaAsignacion;